type InboundCallActionLike = {
    readonly type: string;
    readonly outcome?: string | null;
    readonly response?: string | null;
    readonly shift_patient_name?: string | null;
    readonly shift_number?: number | null;
};

export function formatOutreachResponse(
    response: string | null | undefined,
): string {
    if (!response) {
        return 'Response recorded';
    }

    switch (response) {
        case 'interested':
        case 'available_interested':
            return 'Available';
        case 'not_interested':
        case 'available_not_interested':
        case 'unavailable':
            return 'Unavailable';
        case 'needs_review':
        case 'unknown':
            return 'Needs review';
        case 'pending':
        case 'no_response':
            return 'Pending';
        default:
            return response.replace(/_/g, ' ');
    }
}

export function formatInboundCallActionLabel(
    action: InboundCallActionLike,
): string {
    switch (action.type) {
        case 'shift_confirmation':
            if (action.outcome === 'confirm') {
                return 'Shift confirmation: confirmed';
            }
            if (action.outcome === 'decline') {
                return 'Shift confirmation: declined';
            }
            return 'Shift confirmation updated';

        case 'outreach_response': {
            const shiftPrefix = action.shift_number
                ? `Shift ${action.shift_number}: `
                : '';
            return `${shiftPrefix}${formatOutreachResponse(action.response)}`;
        }

        case 'transfer':
            return 'Transferred to back office';

        default:
            return 'Action recorded';
    }
}

export function getCallCallerLabel(call: {
    readonly caller_name: string | null;
    readonly caller_phone: string | null;
}): string {
    return (
        call.caller_name?.trim() ||
        call.caller_phone?.trim() ||
        'Unknown caller'
    );
}

export function getInboundCallActionPatientLabel(
    action: InboundCallActionLike,
): string {
    if (action.shift_patient_name) {
        return action.shift_patient_name;
    }
    if (action.shift_number) {
        return `Patient ${action.shift_number}`;
    }
    return 'Patient';
}
